<template>
    <div>
        <div id="panel-4" class="panel">
            <div class="panel-container show">
                <div class="panel-content">

                    <pwa_payments_header
                        v-model="filter"
                        @filter="handleFilter"
                        @country-change="handleCountryChange"
                        @gate-change="handleGateChange"
                        @create="createGatewaySetting"
                    />

                    <b-skeleton-table v-if="is_load" :rows=this.cur_records :columns="2" :hide-header=true :table-props="{ bordered: false, striped: true }" />

                    <div class="inbox_vue_list" v-if="!is_load">

                        <div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <pagination_list
                                key="up"
                                :total="pagination.total"
                                :limit="pagination.limit"
                                :current="pagination.pagesCurrent"
                                @page-change="handlePageChange">
                            </pagination_list>
                        </div>

                        <b-table
                            v-if="rows.length > 0"
                            :tbody-tr-class="rowClass"
                            striped class="table-responsive-xl resolution_table" :items="rows" :fields="fields">

                            <!-- header fields -->
                            <template v-slot:head(id)="data">
                                <div class="status_info" style="max-width: 50px">
                                    {{ __t('PROVIDER') }}
                                </div>
                            </template>

                            <template v-slot:head(added)="data">

                                <grid_list
                                    :list_ordering="'created_at'"
                                    :field_name="__t('created_at')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
                            </template>

                            <template v-slot:head(name)="data">
                                <grid_list
                                    :list_ordering="'name'"
                                    :field_name="__t('PAYMENT_NAME')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
                            </template>

                            <template v-slot:head(pay_gate)="data">
                                <grid_list
                                    :list_ordering="'pay_gate'"
                                    :field_name="__t('PAY_GATE')"
                                    :current_ordering="list.ordering"
                                    :current_direction="list.direction"
                                    @update-order="handleOrdering"
                                />
                            </template>


                            <!-- body draw -->
                            <template v-slot:cell(id)="data">
                                <div class="provider_img" >
                                    <div  class="icon">
                                        <img :src=getIcon(data.item) class="order_prov_image" alt="" style="max-width: 65px;">
                                    </div>
                                </div>
                            </template>


                            <template v-slot:cell(name)="data">
                                <div class="">
                                    <div class="d-flex flex-start w-100 fs-xl mb-2" >
                                        <div class="icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer" v-on:click="open_item(data.item)">
                                            <i class="base base-15 icon-stack-3x opacity-100 color-primary-900"></i>
                                            <i class="fal fa-indent icon-stack-1x opacity-100 color-white"></i>
                                            <div class="position-relative mem_count_vue mr-4">
                                                <span>

                                                    <span  class="badge badge-icon pos-top pos-right">
                                                        {{data.item.attached_count}}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                        {{ data.item.name }} #{{data.item.id}}
                                    </div>
                                </div>
                            </template>



                            <template v-slot:cell(pwa_payment)="data">
                                <div>
                                    <div class="mb-2">
                                        <div class="small badge border border-success">
                                            {{data.item.pwa_payment.name}}
                                        </div>
                                    </div>
                                </div>

                            </template>

                            <template v-slot:cell(pay_gate)="data">
                                <div>
                                    <div class="mb-2">
                                        <div class="small badge border border-success">
                                            {{data.item.pay_gate.name}}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </b-table>

                        <div class="inb_pagi pt-4" v-if="rows.length > 0">
                            <pagination_list
                                key="down"
                                :total="pagination.total"
                                :limit="pagination.limit"
                                :current="pagination.pagesCurrent"
                                @page-change="handlePageChange">
                            </pagination_list>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <payment_item @saved="onPaymentSaved" @deleted="onPaymentDeleted"/>

    </div>
</template>

<script>

import {mapGetters} from "vuex";


import pwa_payments_header from "./pwa_payments_header.vue";
import Grid_list from "../../../sys/list/grid_list.vue";
import Pagination_list from "../../../sys/list/pagination_list.vue";
import payment_item from "../item/payment_item.vue";


export default {
    name: "pwa_payments",
    components : {
        Grid_list,
        Pagination_list,
        pwa_payments_header,
        payment_item
    },
    data() {
        return {
            rows: [],
            is_load: true,
            is_check_all: false,
            cur_records: 35,
            component_type: "reviews",
            grid_trigger: "review_inbox_change_state",

            list: {
                ordering: "ordering",
                direction: "DESC",
                start: 0,
                limit: 30
            },

            pagination: {
                total: 0,
                limit: 30,
                pagesCurrent: 1
            },

            filter: {
                search      : "",
                gate_id : 0,
            },

            fields: [
                { key: 'id', label: '', class: '' },
             //   { key: 'attached_count', label: '', class: 'text-left ' },
                { key: 'name', label: '<i class="fas fa-sort"></i>', class: 'text-left ' },
                { key: 'description', label: 'description', class: 'hidden-md-down' },
                { key: 'pay_gate', label: '<i class="fal fa-star width-2"></i>', class: '' },
                { key: 'created_at', label: 'added', class: '' },
            ],

            show_payment_modal: false,
            selected_payment: null,
        }
    },

    mounted() {
        if(window.hasOwnProperty("review_api")) {
            this.load_items();
        }
    },

    created() {
        EventBus.$on("search_review_called",this.search_work);
        EventBus.$on("clean_review_filter",this.clean_inbox_filter);
        EventBus.$on('loaded_api', this.load_items)

    },

    methods : {
        //Header
        handleFilter(filter) {
            this.filter = filter;
            this.list.start = 0;
            this.load_items();
        },

        handleCountryChange(countryCode) {
            this.filter.country_code = countryCode;
        },

        handleGateChange(gateType) {
            this.filter.gate_type = gateType;
        },


        handleOrdering({ordering, direction}) {
            this.list.ordering = ordering;
            this.list.direction = direction;
            this.load_items();
        },

        handlePageChange({page, start}) {
            this.list.start = start;
            this.load_items();
        },

        search_work(search_str) {
            this.filter.search = search_str;
            this.list.start = 0;
            this.load_items();
        },

        filter_select(res) {
            this.filter[res.type] = res.value;
            this.list.start = 0;
            this.load_items();
        },

        clean_inbox_filter() {

            this.filter = {
                search: "",
                provider_id: "",
                "period" : "year",
            };

            this.list = {
                ordering: "ordering",
                direction: "DESC",
                start: 0,
                limit: 30
            };
            this.load_items();
        },

        async load_items() {

            let self = this;
            this.rows = [];
            this.is_load = true;

            await api.post('/internal/v1/catalog/pwa/payments',{
                filter  : this.filter,
                list    : this.list
            })
                .then(({ data }) => {

                    console.log(data);
                    self.is_load = false;
                    if (data.status === "operation_success") {
                        self.rows = data.data;

                        if (data.message?.pagination) {
                            self.pagination = data.message.pagination;
                        }
                    }
                })
                .catch(({ response }) => {
                    self.is_load = false;
                    this.rows = [];
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status
                    });
                });
        },


        getIcon(item) {
            return '/web/payment/icon/' + item.pay_gate.id+ '/' + item.pay_gate.type +'.svg?v=2';
        },

        rowClass(item) {
            if (!item) return;
            return item.class;
        },

        open_item(item) {
            EventBus.$emit('showPayment',item.pay_gate_id,item.id);
        },

        createGatewaySetting() {
            EventBus.$emit('showPayment',this.filter.pay_gate_id,0);
        },


        onPaymentSaved(item) {
            this.show_payment_modal = false;
            this.selected_payment = null;
            this.load_items();
        },

        onPaymentDeleted(id) {
            this.show_payment_modal = false;
            this.selected_payment = null;
            this.load_items();
        },
    },
    computed: {

        ...mapGetters({
            'user' : "user/getUser",
        }),
    }
}
</script>

<style scoped>
.table thead th:first-child {
    max-width: 20px;
}
</style>
